import { render, staticRenderFns } from "./ManageChecklists.vue?vue&type=template&id=b627f44e&"
import script from "./ManageChecklists.vue?vue&type=script&lang=js&"
export * from "./ManageChecklists.vue?vue&type=script&lang=js&"
import style0 from "./ManageChecklists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports